import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // ✅ Envoyer les cookies httpOnly automatiquement (fallback)
  headers: { 'Content-Type': 'application/json' },
});

/**
 * Keeps the token the API returned, or forgets any older one when the API
 * returned none: in cookie-only mode the httpOnly session cookie is enough.
 */
export function rememberSessionToken(token: string | undefined): void {
  if (token) localStorage.setItem('access_token', token);
  else localStorage.removeItem('access_token');
}

// Intercepteur: injecter le token JWT depuis localStorage dans les headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur: si 401, nettoyer le token et rediriger vers login
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // A failed logout is not an expired session: the caller signs out locally.
    if (error?.response?.status === 401 && error.config?.url !== '/auth/logout') {
      // Supprimer le token invalide
      localStorage.removeItem('access_token');

      // Ne pas rediriger si on est sur une page publique d'authentification
      const currentPath = window.location.pathname;
      // Pages anyone may view: the startup session probe must not bounce visitors away.
      const publicAuthPages = [
        '/login',
        '/register',
        '/forgot-password',
        '/reset-password',
        '/verify-email',
        '/privacy',
        '/terms',
      ];
      const isOnPublicAuthPage = publicAuthPages.some((page) => currentPath.includes(page));

      if (!isOnPublicAuthPage) {
        // Optionnel: conserver l'URL courante pour revenir après login
        const from = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?from=${from}`;
      }
    }

    return Promise.reject(error);
  }
);
